/* Potencia — additions: bench read-more + LinkedIn in bio modal */
(function () {
  document.querySelectorAll(".bench-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var s = btn.closest(".bench");
      s.classList.toggle("open");
      btn.textContent = s.classList.contains("open") ? "Read less" : "Read more";
    });
  });
  document.querySelectorAll(".bio-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var card = btn.closest(".tm, .founder");
      if (!card) return;
      setTimeout(function () {
        var m = document.getElementById("bio-modal");
        if (!m) return;
        var oldLi = m.querySelector(".bm-head .li-link");
        if (oldLi) oldLi.remove();
        var cardLi = card.querySelector(".li-link");
        if (cardLi) {
          var host = m.querySelector(".bm-head > div");
          if (host) host.appendChild(cardLi.cloneNode(true));
        }
      }, 0);
    });
  });
})();